import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { Icon } from "@material-ui/core";
import TouchRipple from "@material-ui/core/ButtonBase";
import MatxVerticalNavExpansionPanel from "./MatxVerticalNavExpansionPanel";
import { withStyles } from "@material-ui/styles";
import { useSelector, useDispatch } from "react-redux";
import Loading from "../../../matx/components/MatxLoadable/Loading";

const styles = (theme) => ({
  expandIcon: {
    transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
    transform: "rotate(90deg)",
  },
  collapseIcon: {
    transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
    transform: "rotate(0deg)",
  },
});

class MatxVerticalNav extends Component {
  state = {
    collapsed: true,
  };

  renderLevels = (data, user) => {
    // data[0].display = "none";
    // data[1].user = user;
    // console.log("nav",user)
    if (
      user !== undefined &&
      user["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] !==
        undefined
    ) {
      data.map((item, index) => {
        if (data[index].name === "LSS") {
          if (
            user[
              "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
            ].includes("LSS_User") ||
            user[
              "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
            ].includes("System_Admin") ||
            user[
              "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
            ].includes("LSS_Owner")
          ) {
            data[index].display = null;
          } else {
            data[index].display = "none";
          }
        }
        if (data[index].name === "Configuration") {
          if (
            user[
              "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
            ].includes("System_Admin")
          ) {
            data[index].display = null;
          } else {
            data[index].display = "none";
          }
        }
        if (data[index].name === "Personal Days") {
          if (
            user[
              "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
            ].includes("System_Admin") ||
            user[
              "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
            ].includes("PD_Owner") ||
            user[
              "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
            ].includes("PD_User")
          ) {
            data[index].display = null;
          } else {
            data[index].display = "none";
          }
        }
        if (data[index].name === "Payroll") {
          if (
            user[
              "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
            ].includes("System_Admin") ||
            user[
              "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
            ].includes("payroll_User")
          ) {
            data[index].display = null;
          } else {
            data[index].display = "none";
          }
        }
        if (data[index].role) {
          if (
            user[
              "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
            ].includes(data[index].role)
          ) {
            data[index].display = null;
          } else {
            data[index].display = "none";
          }
        }
        if (item.children) {
          item.children.map((item2, index2) => {
            if (data[index].name === "Venta de Activos") {
              if (
                user[
                  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
                ].includes("AssetsSale_User") ||
                user[
                  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
                ].includes("System_Admin") ||
                user[
                  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
                ].includes("AssetsSale_Owner")
              ) {
                data[index].display = null;
                if (item2.name === "Ventas Home") {
                  data[index].children[index2].display = null;
                }
              } else {
                data[index].display = "none";
                if (item2.name === "Ventas Home") {
                  data[index].children[index2].display = "none";
                }
              }
            }
            if (data[index].name === "Benefits") {
              if (
                user[
                  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
                ].includes("Benefits_User") ||
                user[
                  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
                ].includes("System_Admin") ||
                user[
                  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
                ].includes("Benefits_Owner")
              ) {
                data[index].display = null;
                if (item2.name === "Benefits Home") {
                  data[index].children[index2].display = null;
                }
              } else {
                data[index].display = "none";
                if (item2.name === "Benefits Home") {
                  data[index].children[index2].display = "none";
                }
              }
            }
            if (data[index].name === "Bring a friend") {
              if (
                user[
                  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
                ].includes("Raft_User") ||
                user[
                  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
                ].includes("System_Admin") ||
                user[
                  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
                ].includes("Raft_Owner")
              ) {
                data[index].display = null;
                if (item2.name === "BAF Home") {
                  data[index].children[index2].display = null;
                }
              } else {
                data[index].display = "none";
                if (item2.name === "BAF Home") {
                  data[index].children[index2].display = "none";
                }
              }
            }
            if (data[index].name === "Settings") {
              if (
                user[
                  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
                ].includes("System_Admin") ||
                user[
                  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
                ].includes("Home_Owner")
              ) {
                data[index].display = null;
                if (item2.name === "Menu Settings") {
                  data[index].children[index2].display = null;
                }
                if (item2.name === "Video Settings") {
                  data[index].children[index2].display = null;
                }
                if (item2.name === "Kudos Settings") {
                  data[index].children[index2].display = null;
                }
                if (item2.name === "Calendar Settings") {
                  data[index].children[index2].display = null;
                }
                if (item2.name === "Banners Settings") {
                  data[index].children[index2].display = null;
                }
                if (item2.name === "Ask Alejandro Settings") {
                  data[index].children[index2].display = null;
                }
                if (item2.name === "Chatbot Settings") {
                  data[index].children[index2].display = null;
                }
                if (item2.name === "Contact Settings") {
                  data[index].children[index2].display = null;
                }
              } else {
                data[index].display = "none";
                if (item2.name === "Menu Settings") {
                  data[index].children[index2].display = "none";
                }
                if (item2.name === "Video Settings") {
                  data[index].children[index2].display = "none";
                }
                if (item2.name === "Kudos Settings") {
                  data[index].children[index2].display = "none";
                }
                if (item2.name === "Calendar Settings") {
                  data[index].children[index2].display = "none";
                }
                if (item2.name === "Banners Settings") {
                  data[index].children[index2].display = "none";
                }
                if (item2.name === "Ask Alejandro Settings") {
                  data[index].children[index2].display = "none";
                }
                if (item2.name === "Chatbot Settings") {
                  data[index].children[index2].display = "none";
                }
                if (item2.name === "Contact Settings") {
                  data[index].children[index2].display = "none";
                }
              }
            }
            //AssetsSale
            if (
              user[
                "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
              ].includes("System_Admin") ||
              user[
                "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
              ].includes("AssetsSale_Owner")
            ) {
              if (
                item2.name === "Administración Campaña" ||
                item2.name === "Administración Inventario" ||
                item2.name === "Administración Edificios" ||
                item2.name === "Consulta de Compras" ||
                item2.name === "Consulta sobre Artículos Comprados"
              ) {
                data[index].children[index2].display = null;
              }
            } else {
              if (
                item2.name === "Administración Campaña" ||
                item2.name === "Administración Inventario" ||
                item2.name === "Administración Edificios" ||
                item2.name === "Consulta de Compras" ||
                item2.name === "Consulta sobre Artículos Comprados"
              ) {
                data[index].children[index2].display = "none";
              }
            }
            //Benefits
            if (
              user[
                "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
              ].includes("System_Admin") ||
              user[
                "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
              ].includes("Benefits_Owner")
            ) {
              if (item2.name === "Admin Benefits") {
                data[index].children[index2].display = null;
              }
            } else {
              if (item2.name === "Admin Benefits") {
                data[index].children[index2].display = "none";
              }
            }
            //Raft
            if (
              user[
                "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
              ].includes("System_Admin") ||
              user[
                "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
              ].includes("Raft_Owner")
            ) {
              if (item2.name === "BAF Calendar Settings") {
                data[index].children[index2].display = null;
              }
              if (item2.name === "BAF Video Settings") {
                data[index].children[index2].display = null;
              }
              if (item2.name === "BAF Banners Settings") {
                data[index].children[index2].display = null;
              }
            } else {
              if (item2.name === "BAF Calendar Settings") {
                data[index].children[index2].display = "none";
              }
              if (item2.name === "BAF Video Settings") {
                data[index].children[index2].display = "none";
              }
              if (item2.name === "BAF Banners Settings") {
                data[index].children[index2].display = "none";
              }
            }
            //Newsletters
            if (
              (user[
                "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
              ].includes("System_Admin") ||
                user[
                  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
                ].includes("Newsletters_User") ||
                user[
                  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
                ].includes("Newsletters_Owner")) &&
              data[index].name === "Newsletter"
            ) {
              data[index].display = null;
              //Is admin or owner shows all.
              if (
                (user[
                  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
                ].includes("System_Admin") ||
                  user[
                    "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
                  ].includes("Newsletters_Owner"))
              ) {
                item2.display = null;
              }
              //Home
              if (item2.name === "Home") {
                user[
                  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
                ].includes("Newsletters_User")
                  ? (item2.display = null)
                  : (item2.display = "none");
              }
            }
          });
        }
      });
    }
    // Se trae la variable con los tabs que deben mostrarse y se revisa para modificar el display, en caso de ser false se pone display "none"
    // y en caso de true no se hace nada para que se muestre
    return data.map((item, index) => {
      if (item.children) {
        return (
          <MatxVerticalNavExpansionPanel
            item={item}
            key={index}
            display={item.display ? item.display : null}
          >
            {this.renderLevels(item.children)}
          </MatxVerticalNavExpansionPanel>
        );
      } else {
        return (
          <NavLink
            key={index}
            to={item.role ? { pathname: item.path } : item.path}
            target={item.isTab ? "_blank" : "_parent"}
            style={{ display: item.display ? item.display : null }}
            className="nav-item"
          >
            <TouchRipple key={item.name} name="child" className="w-100">
              {(() => {
                if (item.icon) {
                  return (
                    <Icon className="item-icon text-middle">{item.icon}</Icon>
                  );
                } else {
                  return (
                    <span className="item-icon icon-text">{item.iconText}</span>
                  );
                }
              })()}
              <span
                style={{ paddingLeft: "15px", wordBreak: "break-word" }}
                className="text-middle item-text"
              >
                {item.name}
              </span>
              <div className="mx-auto"></div>
              {item.badge && (
                <div className={`badge bg-${item.badge.color}`}>
                  {item.badge.value}
                </div>
              )}
            </TouchRipple>
          </NavLink>
        );
      }
    });
  };

  handleClick = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };

  render() {
    // console.log("nav user", this.props.user);
    return (
      <div className="navigation">
        {this.renderLevels(this.props.navigation, this.props.user)}
      </div>
    );
  }
}

export default withStyles(styles)(MatxVerticalNav);
